import EventEmitter from 'events';
const emitter = new EventEmitter();
const mediaEvents = {
    event(...args) {
        this._event = args.join('.');
        return this;
    },
    listen(handler) {
        emitter.on(this._event, handler);
    },
    remove(handler) {
        emitter.off(this._event, handler);
    },
    emit(data) {
        emitter.emit(this._event, data);
    },
};
export default mediaEvents;
